"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.advanced-reports.disabled': 'Advanced reports feature is not available in your current plan.',
};
